/**
 * Central brand naming for venue / subscription categories.
 *
 * The stored + API values remain 'champion' / 'premium' (all casings). Only the
 * face value shown to the user changes:
 *   champion  -> FitX
 *   premium   -> ZoneX
 *   affiliate -> Affiliate
 *
 * Use `mapBrandLabel()` (or the `brandLabel` pipe) on ANY value rendered in the
 * UI that may carry a category name, including values coming straight from the
 * backend.
 */
export const BRAND_LABEL_MAP: { [key: string]: string } = {
    champion: 'FitX',
    premium: 'ZoneX',
    affiliate: 'Affiliate',
};

const BRAND_LABEL_REGEX = /\b(champion|premium|affiliate)s?\b/gi;

/**
 * Replaces every occurrence of champion/premium (any casing, anywhere inside the
 * string) with its brand name. Non-string values are returned untouched, so this
 * is safe to apply blindly to table cells and detail fields.
 */
export function mapBrandLabel(value: any): any {
    if (typeof value !== 'string' || !value) {
        return value;
    }
    return value.replace(
        BRAND_LABEL_REGEX,
        (match: string) => BRAND_LABEL_MAP[match.toLowerCase().replace(/s$/, '')]
    );
}
